import { useIsSkincare } from 'hooks/useIsSkincare';
import type { AvailableRouteNames } from 'utils/getSiteSpecificRoutes';
import { getSiteSpecificRoutes } from 'utils/getSiteSpecificRoutes';

export const useSiteSpecificRoutes = (routeNames: AvailableRouteNames[]) => {
  const isSkincare = useIsSkincare();

  return getSiteSpecificRoutes(isSkincare, routeNames);
};
